<template>
  <el-row style="background-color: #E9EEF3; padding: 10px">
    <el-container>
      <el-aside width="200px" :style="{'background-color': 'white','height': pageHeight}">
        <el-scrollbar style="height: 100%">
          <!--          商品分类-->
          <el-button icon="el-icon-plus" style="margin-top: 10px" @click="dialogFormVisible2 = true">新建分类</el-button>
          <el-menu :default-active="leftMenuBar.activeIndex1" @select="handleCategorySelect">
            <template v-for="category in categories">
              <el-menu-item :index="category.id.toString()" :key="category.id" class="categoryEditBtn">
                <el-button type="text" style="width: 20px"
                           v-if="categories.indexOf(category) !== 0"
                           @click="moveUpCategory(category)">
                  <el-icon class="el-icon-top"></el-icon>
                </el-button>
                <!--                占位罢了，不想仔细设置样式了-->
                <el-button v-else type="text" style="width: 20px">
                  <el-icon class=""></el-icon>
                </el-button>
                <el-button type="text" style="margin-left: unset;width: 20px"
                           v-if="categories.indexOf(category) !== categories.length-1"
                           @click="moveDownCategory(category)">
                  <el-icon class="el-icon-bottom"></el-icon>
                </el-button>
                <!--                占位-->
                <el-button v-else type="text" style="margin-left: unset;width: 20px">
                  <el-icon class=""></el-icon>
                </el-button>
                <el-input v-if="editCategoryNameVal.inputFlag &&
                editCategoryNameVal.categoryIndex === categories.indexOf(category)"
                          v-model="editCategoryNameVal.categoryVal" size="small"
                          @change="submitCategoryName(category)"
                          @blur="editCategoryNameVal.inputFlag = false"
                          class="editCategoryInput"></el-input>
                <span v-else>
                  {{ category.title }}
                </span>
                <el-button type="text" style="margin-left: unset;width: 20px"
                           @click="editCategoryName(category)">
                  <el-icon class="el-icon-edit"></el-icon>
                </el-button>
                <el-button type="text" style="margin-left: unset;width: 20px"
                           @click="deleteCategory(category.id)">
                  <el-icon class="el-icon-delete"></el-icon>
                </el-button>
              </el-menu-item>
            </template>
<!--            <el-menu-item :index="1000">{{String.fromCodePoint('0x1F49D') + '心愿单'}}</el-menu-item>-->
          </el-menu>
        </el-scrollbar>
      </el-aside>
      <el-container style="padding: 0;">
        <el-main style="padding: 0; background-color: white">
          <el-scrollbar style="width: 100%">
            <el-row style="border-bottom: 1px solid #e6e6e6;">
              <el-col :span="20">
                <el-menu :default-active="activeIndex2" class="el-menu-demo" mode="horizontal"
                         @select="handleStatusSelect">
                  <template v-for="item in menuItems">
                    <el-menu-item :index="item.index" :key="item.index">
                      {{ item.title }}
                    </el-menu-item>
                  </template>
                </el-menu>
              </el-col>
              <el-col :span="4">
                <el-button type="primary"
                           size="medium"
                           icon="el-icon-plus"
                           style="margin-top: 10px"
                           @click="toRegisterOrEdit('新建商品')">
                  新建商品
                </el-button>
              </el-col>
            </el-row>
            <el-row style="padding-top: 10px;padding-bottom: 10px;background-color: white" :gutter="20">
              <el-col :span="statusMenu.choiceStatus === '已上架' ? 8 : 6">
                <span>批量操作：</span>
                <el-button-group>
                  <el-button size="mini"
                             type="primary"
                             @click="batchOperationOfOnSale"
                             :disabled="onSaleDisabledFlag">上架
                  </el-button>
                  <el-button size="mini"
                             type="primary"
                             @click="batchOperationOfOffSale"
                             :disabled="offSaleDisabledFlag">下架
                  </el-button>
                  <el-button size="mini"
                             type="primary"
                             v-if="statusMenu.choiceStatus === '已上架'"
                             @click="handleMultiDiscount">活动
                  </el-button>
                </el-button-group>
              </el-col>
              <el-col :span="6">
                <el-select v-model="sortedFlag" placeholder="请选择排序方式" @change="getSortedFlag($event)" size="mini">
                  <el-option label=" " value="0"></el-option>
                  <el-option label="按创建时间升序" value="1"></el-option>
                  <el-option label="按商品名称升序" value="2"></el-option>
                  <el-option label="按修改时间升序" value="3"></el-option>
                  <el-option label="按创建时间降序" value="4"></el-option>
                  <el-option label="按商品名称降序" value="5"></el-option>
                  <el-option label="按修改时间降序" value="6"></el-option>
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-input
                    placeholder="请输入商品名称搜索"
                    v-model="searchInput"
                    size="mini"
                    @change="searchSkuProduct">
                  <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click="searchSkuProduct(searchInput)"></el-button>
                </el-input>
              </el-col>
            </el-row>
            <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                :header-cell-style="headerClass"
                @selection-change="handleSelectionChange"
                @select-all="selectAll"
                v-loading="tableDataLoading"
            >
              <el-table-column align="center" width="65" type="selection">
              </el-table-column>
              <el-table-column
                  prop="img"
                  label="图片"
                  align="center">
                <template slot-scope="scope">
                  <el-image
                      :src="scope.row.image[0]"
                      style="width:50px; height: 50px"
                      fit="fill"
                      :key="scope.row.image[0]">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column
                  prop="title"
                  label="名称"
                  show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                  prop="price"
                  label="售价 (元)"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="stock"
                  label="库存"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="specification"
                  label="规格"
                  align="center">
              </el-table-column>
              <el-table-column
                  v-if="statusMenu.choiceStatus === '待审核'"
                  prop=""
                  label="审核状态"
                  align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.status === 3" style="color: green">审核中</span>
                  <span v-if="scope.row.status === 4" style="color: red">已驳回</span>
                  <el-tooltip class="item" effect="dark"
                              :content="scope.row.operationReason"
                              placement="top"
                              v-if="scope.row.status === 4"
                  >
                    <div v-if="scope.row.status === 4" class="rejectReason">
                      {{ scope.row.operationReason }}
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column v-if="statusMenu.choiceStatus === '已上架'"
                               prop=""
                               label="活动"
                               align="left">
                <template slot-scope="scope">
                  <el-tag v-for="item in scope.row.promotion" :key="'table' + item.promotionId" size="small"
                          style="margin-left: unset;margin-bottom: 4px;margin-right: 10px"
                          :class="'promotionColor' + item.promotionId % 5"
                  >{{ item.title }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                  prop="operation"
                  label="操作"
                  width="250"
                  align="center">
                <template slot-scope="scope">
                  <!--                    待审核部分的定制按钮-->
                  <template v-if="statusMenu.choiceStatus === '待审核'">
                    <el-button type="text" @click="editSpecifications(scope.row)">新增规格
                    </el-button>
                    <el-button type="text" @click="withdrawPending(scope.row.id)">撤回提交</el-button>
                    <el-button v-if="scope.row.status === 4" type="text"
                               @click="toRegisterOrEdit('编辑待审核商品',scope.row)">编辑
                    </el-button>
                  </template>
                  <template v-else>
                    <el-button type="text" v-if="statusMenu.choiceIndex === '1' && scope.row.priority === 0"
                               @click="pinProductBySpuId(scope.row.spuId)">置顶
                    </el-button>
                    <el-button type="text" v-if="statusMenu.choiceIndex === '1' && scope.row.priority === 1"
                               @click="unpinProductBySpuId(scope.row.spuId)">取消置顶
                    </el-button>
                    <el-button type="text" @click="toRegisterOrEdit('编辑商品',scope.row)">编辑</el-button>
                    <el-button type="text" v-if="statusMenu.choiceIndex === '1'"
                               @click="handleSingleDiscount(scope.row)">活动
                    </el-button>
                    <el-button v-if="statusMenu.choiceIndex !== '0'
                  && statusMenu.choiceIndex !== '1'
                  && statusMenu.choiceIndex !=='2'
                  && statusMenu.choiceIndex !== '3'"
                               type="text"
                               @click="editSpecifications(scope.row)">新增规格
                    </el-button>
                    <el-button v-if="statusMenu.choiceIndex === '1' || statusMenu.choiceIndex === '3'"
                               type="text"
                               @click="downShelfProduct(scope.row.id)">
                      下架
                    </el-button>
                    <el-button v-if="statusMenu.choiceIndex ==='0' || statusMenu.choiceIndex === '2'"
                               type="text"
                               @click="onShelfProduct(scope.row.id)">
                      上架
                    </el-button>
                    <el-button type="text" @click="deleteProduct(scope.row.id, scope.row.status)">删除</el-button>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </el-scrollbar>

        </el-main>
        <el-footer style="background-color: white">
          <el-col :span="24">
            <el-pagination
                @size-change="handlePageSizeChange"
                @current-change="handleCurrentPageChange"
                :current-page="pageInfo.current"
                :page-sizes="[10, 50, 100]"
                :page-size="pageInfo.size"
                layout="sizes, prev, pager, next, total"
                :total="pageInfo.total">
            </el-pagination>
          </el-col>
        </el-footer>
      </el-container>
    </el-container>
    <!--    新建商品-->
    <el-dialog :title="mode"
               :visible.sync="dialogFormVisible"
               width="750px"
               :before-close="handleDialogClose"
               @close="initDialog('form')"
    >
      <el-form ref="form"
               :model="form"
               :rules="rules"
               label-width="80px"
               style="margin-right: 10px; margin-left: 10px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品名称" prop="spuTitle">
              <el-input v-model="form.spuTitle" :disabled="disabledTitleFlag" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品分类" prop="spuClassId">
              <el-select v-model="form.spuClassId" placeholder="请选择" :disabled="disabledClassFlag">
                <el-option
                    v-for="item in categories"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="单价(元)" prop="skuPrice">
              <el-input v-model="form.skuPrice">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品库存" prop="skuStock">
              <el-input v-model.number="form.skuStock"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="规格类型" prop="skuTag">
              <el-select v-model="form.skuTag" placeholder="请选择">
                <el-option v-for="item in tags" :key="item.index" :label="item.title" :value="item.index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格" prop="skuSpecification">
              <el-input v-model="form.skuSpecification" maxlength="255"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品来源" prop="source">
              <el-input v-model="form.source" placeholder="请输入" maxlength="255">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="价格对比" prop="priceComparison" class="is-required imageUpload">
              <el-upload
                  action=""
                  :multiple="true"
                  :on-remove="handlePriceRemove"
                  :http-request="httpRequestOfPriceComparison"
                  :file-list="priceImg"
                  list-type="picture-card">
              </el-upload>
              <div v-if="imgValid" class="el-upload__tip" style="color: #ee4234;line-height: 0">
                可上传多张图片
              </div>
              <div v-else class="el-upload__tip" style="color: #ee4234;line-height: 0">可上传多张图片（必填）
              </div>
              <div v-if="priceImg.length !== 0" class="el-upload__tip" style="line-height: 0;margin-top: 12px"
              >比价日期：{{ priceDate }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="24">
          <el-form-item label="商品描述" prop="spuDescription">
            <el-input type="textarea" v-model="form.spuDescription" maxlength="1000"
                      show-word-limit></el-input>
          </el-form-item>
        </el-col>
        <!--        <el-col :span="24" v-if="mode==='新增规格' || mode ==='新建商品'">-->
        <el-col :span="24">
          <el-form-item label="上传主图" prop="images" class="is-required imageUpload">
            <el-upload
                action=""
                :multiple="true"
                :http-request="httpRequestOfImage"
                :on-remove="handleImgRemove"
                :file-list="imageList"
                list-type="picture-card">
              <!--              <div v-if="imgValid" slot="tip" class="el-upload__tip" style="color: #ee4234;line-height: 0">可上传多张图片</div>-->
              <!--              <div v-else slot="tip" class="el-upload__tip" style="color: #ee4234;line-height: 0">可上传多张图片（必填）</div>-->
            </el-upload>
            <div v-if="imgValid" class="el-upload__tip" style="color: #ee4234;line-height: 0">可上传多张图片</div>
            <div v-else class="el-upload__tip" style="color: #ee4234;line-height: 0">可上传多张图片（必填）</div>
          </el-form-item>
        </el-col>
        <!--        <el-col :span="24" v-if="mode==='新增规格' || mode ==='新建商品'">-->
        <el-col :span="24">
          <el-form-item label="上传详情" prop="posts" class="imageUpload">
            <el-upload
                action=""
                :multiple="true"
                :http-request="httpRequestOfPost"
                :on-remove="handlePostRemove"
                :file-list="postImg"
                list-type="picture-card">
            </el-upload>
            <div class="el-upload__tip" style="color: #ee4234;line-height: 0">请上传海报</div>
          </el-form-item>
        </el-col>
        <el-col>
        </el-col>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmit('form')">{{ buttonInfo }}</el-button>
      </span>

    </el-dialog>
    <!--    新增商品分类-->
    <el-dialog title="新建分类"
               :visible.sync="dialogFormVisible2"
               :before-close="handleDialogClose"
               @close="initDialog2"
               center
    >
      <el-row type="flex" justify="center">
        <el-col :span="8">
          <el-input v-model="title" placeholder="请输入新分类"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addCategories">新建</el-button>
      </span>
    </el-dialog>
    <!--    优惠折扣-->
    <el-dialog title="活动设置" :visible.sync="promotion.dialogVisible" @close="cancelPromotionEdit">
      <el-row class="salesPromotion">
        <el-col :span="8" class="" style="margin-bottom: 8px">现有的优惠活动</el-col>
        <el-col :span="16" style="margin-bottom: 8px">
          <el-tag
              :key="'existed' + tag.id"
              v-for="tag in promotion.existedPromotionTag"
              :disable-transitions="false"
              @click="addPromotionTag(tag)"
              :class="'promotionColor' + tag.id % 5"
          >
            {{ tag.title }}
          </el-tag>
        </el-col>
        <template>
          <el-col :span="8">已参加的优惠活动</el-col>
          <el-col :span="16">
            <el-tag v-for="tag in promotion.selectedPromotionTag"
                    closable
                    :key="'selected' + tag.id"
                    :class="'promotionColor' + tag.promotionId % 5"
                    @close="deleteSinglePromotionTag(tag)">{{ tag.title }}
            </el-tag>
          </el-col>
        </template>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" plain @click="cancelPromotionEdit">取消</el-button>
        <el-button type="primary" @click="submitPromotionList">确定</el-button>
      </span>
    </el-dialog>
  </el-row>

</template>

<script>
import GLOBAL from "@/utils/global.js";
export default {
  name: "CommodityManagement",
  components: {},
  data() {
    return {
      GLOBAL,
      //页面高度
      pageHeight: '',
      //搜索内容
      searchInput: '',
      //该分类下的所有商品的数量
      totalCountByAllStatus: 0,
      //排序参数
      orderMethod: {
        order: '',
        orderKey: '',
      },
      //排序方式
      sortedFlag: '0',
      //左侧菜单
      leftMenuBar: {
        categoryChoice: '',
        activeIndex1: '',
      },
      //编辑商品分类名称相关
      editCategoryNameVal: {
        inputFlag: false,
        categoryVal: '',
        categoryIndex: 1000
      },
      //复选框相关，批量操作
      // checkbox:{
      //   selectAll:false,
      //   isIndeterminate: true,
      //所有的商品的id列表
      // productsIdList:[],
      //目前已选的商品id列表
      //   checkedProducts:[],
      // },
      title: '',
      disabledTitleFlag: false,
      disabledClassFlag: false,
      //上架禁用
      onSaleDisabledFlag: false,
      //下架禁用
      offSaleDisabledFlag: false,
      mode: '',
      buttonInfo: '',
      activeIndex2: 'all',
      //编辑中，是否修改了名称和规格而产生重名
      //false是没有重名
      editTitleFlag: false,
      editSpecFlag: false,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      //状态选择
      statusMenu: {
        choiceIndex: '',
        choiceStatus: '全部',
      },
      //优惠活动相关
      promotion: {
        batchMode: false,
        dialogVisible: false,
        product: {
          spuId: 0,
          promotion: [],
        },
        existedPromotionTag: [],
        selectedPromotionTag: [],
        multiTableData: [],
      },
      // 分页信息
      pageInfo: {
        // 分页信息
        current: 1,
        size: 10,
        total: 0,
      },
      //填写的表单
      form: {
        spuTitle: '',
        spuDescription: '',
        spuImage: [],
        spuClassId: '',
        skuSpecification: '',
        skuTag: '',
        source: '',
        priceComparison: [],
        skuImage: [],
        skuPrice: '',
        skuStock: '',
        images: [],
        posts: [],
        skuComparison: [],
      },
      formBack: {
        spuTitle: '',
        spuDescription: '',
        spuImage: [],
        spuClassId: '',
        skuSpecification: '',
        skuTag: '',
        source: '',
        priceComparison: [],
        skuImage: [],
        skuPrice: '',
        skuStock: '',
        images: [],
        posts: [],
        skuComparison: [],
      },
      //表单
      //提交的表单
      productForm: {
        spu: {
          title: '',
          description: '',
          image: [],
          classId: '',
        },
        sku: {
          specification: '',
          tag: '',
          image: [],
          post: [],
          price: '',
          comparison: [],
          stock: '',
          source: '',
        }
      },
      //上传部分的图片预览数组
      imageList: [],
      imgValid: true,
      //上传海报，sku级别
      postImg: [],
      //比价图片
      priceImg: [],
      priceDate: '',
      //规格表单
      specificationForm: {},
      // 验证规则
      rules: {
        spuTitle: [
          {required: true, message: '请输入商品名称', trigger: 'blur'},
          {max: 28, message: '不超过28个字符', trigger: 'blur'}
        ],
        spuClassId: [
          {required: true, message: '请选择商品类别', trigger: 'change'}
        ],
        skuPrice: [
          {required: true, message: '请输入价格',},
        ],
        skuStock: [
          {required: true, message: '请输入库存',},
        ],
        skuTag: [
          {required: true, message: '请选择规格类别', trigger: 'change'},
        ],
        skuSpecification: [
          {required: true, message: '每次只能输入一种规格',},
          {max: 254, message: '不超过254个字符', trigger: 'blur'}
        ],
        source: [
          {required: true, message: '请输入商品来源', trigger: 'blur'},
          {max: 254, message: '不超过254个字符', trigger: 'blur'}
        ],
        spuDescription: [
          {required: true, message: '请输入商品描述',},
        ],
      },
      //表格数据
      tableData: [],
      //表格数据加载
      tableDataLoading: true,
      //新增类别的表单
      categoryForm: {
        title: '',
      },
      //商品类别
      categories: [],
      //规格类别
      tags: [
        {
          title: '尺码',
          index: 'SIZE_CHINESE'
        },
        {
          title: '非尺码',
          index: 'SIZE_ENGLISH'
        }
      ],
      //多选
      multipleSelection: [],
      selectedIds: [],
      //顶部导航栏
      menuItems: [
        {
          title: "全部商品",
          index: "all",
        },
        {
          title: "已上架",
          index: "1",
        },
        {
          title: "已下架",
          index: "0",
        },
        {
          title: "已售罄",
          index: "3",
        },
        {
          title: "可售",
          index: "2",
        },
        {
          title: "待审核",
          index: "4",
        }
      ],
      //商品级，收到的是返回的spuId
      spuId: 0,
      //款式级，收到的是返回的id
      skuId: 0,
      //  销量
      sales: 0,
      changedName: '',
    };
  },
  created() {
    this.initPageData();
  },
  mounted() {
    this.pageHeight = document.documentElement.clientHeight - 60 - 10 + 'px';
    window.onresize = function () {
      this.pageHeight = document.documentElement.clientHeight - 60 - 10 + 'px';
    };
  },
  methods: {
    //排序显示商品
    getSortedFlag(e) {
      if (e === '1') {
        this.orderMethod.order = 'asc';
        this.orderMethod.orderKey = 'createdTime';
      } else if (e === '2') {
        this.orderMethod.order = 'asc';
        this.orderMethod.orderKey = 'title';
      } else if (e === '3') {
        this.orderMethod.order = 'asc';
        this.orderMethod.orderKey = 'updatedTime';
      } else if (e === '4') {
        this.orderMethod.order = 'desc';
        this.orderMethod.orderKey = 'createdTime';
      } else if (e === '5') {
        this.orderMethod.order = 'desc';
        this.orderMethod.orderKey = 'title';
      } else if (e === '6') {
        this.orderMethod.order = 'desc';
        this.orderMethod.orderKey = 'updatedTime';
      } else if (e === '0') {
        this.orderMethod.order = '';
        this.orderMethod.orderKey = '';
      }
      if(!this.$store.state.visitorMode && GLOBAL.debugMode){
        console.log(e);
        console.log(this.orderMethod);
      }
    },
    //文件上传覆盖原生elem
    httpRequestOfImage(param) {
      let fileObj = param.file; // 相当于input里取得的files
      let formData = new FormData(); // FormData 对象
      formData.append("file", fileObj); // 文件对象
      formData.append('type', '商品主图');
      this.$store.dispatch("Product/uploadImg", formData)
          .then((res) => {
            this.imageList.push({'name': res.data.data.slice(38), 'url': res.data.data});
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
    },
    httpRequestOfPost(param) {
      let fileObj = param.file; // 相当于input里取得的files
      let formData = new FormData(); // FormData 对象
      formData.append("file", fileObj); // 文件对象
      formData.append('type', '商品海报');
      this.$store.dispatch("Product/uploadImg", formData)
          .then((res) => {
            this.postImg.push({'name': res.data.data.slice(38), 'url': res.data.data});
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
    },
    httpRequestOfPriceComparison(param) {
      let fileObj = param.file; // 相当于input里取得的files
      let formData = new FormData(); // FormData 对象
      formData.append("file", fileObj); // 文件对象
      formData.append('type', '比价图片');
      this.$store.dispatch("Product/uploadImg", formData)
          .then((res) => {
            //比价日期
            let date = new Date();
            this.priceDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日';
            this.priceImg.push({'name': res.data.data.slice(38), 'url': res.data.data, 'time': this.priceDate});
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(this.priceDate);
            }
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
    },
    //删除某个上传的图片
    handleImgRemove(file) {
      // console.log(file);
      let index = 0;
      for (let i = 0; i < this.imageList.length; i++) {
        if (file.url === this.imageList[i].url) {
          index = i;
        }
      }
      this.imageList.splice(index, 1);
    },
    //删除上传的海报
    handlePostRemove(file) {
      let index = 0;
      for (let i = 0; i < this.postImg.length; i++) {
        if (file.url === this.postImg[i].url) {
          index = i;
        }
      }
      this.postImg.splice(index, 1);
    },
    //删除某个比价的图片
    handlePriceRemove(file) {
      let index = 0;
      for (let i = 0; i < this.priceImg.length; i++) {
        if (file.url === this.priceImg[i].url) {
          index = i;
        }
      }
      this.priceImg.splice(index, 1);
    },
    //新建商品或者编辑商品
    toRegisterOrEdit(mode, info) {
      this.mode = mode;
      console.log(mode)
      this.imageList = [];
      this.postImg = [];
      this.priceImg = [];
      this.dialogFormVisible = true;
      //使表格里有内容
      if (mode === '编辑商品' || mode === '编辑待审核商品') {
        this.buttonInfo = '确认编辑';
        this.form.spuTitle = info.title;
        this.changedName = info.title;
        this.form.spuClassId = info.classId;
        this.form.spuDescription = info.description;
        this.form.skuPrice = info.price;
        this.form.skuStock = info.stock;
        this.form.skuTag = info.tag;
        this.form.skuSpecification = info.specification;
        this.form.source = info.source;
        this.skuId = info.id;
        this.spuId = info.spuId;
        this.sales = info.sales;
        this.disabledTitleFlag = mode !== '编辑商品';
        this.disabledClassFlag = true;
        for (let i = 0; i < info.image.length; i++) {
          this.imageList.push({'name': info.image[i].slice(38), 'url': info.image[i]})
        }
        // console.log(this.imageList,'+++');
        for (let i = 0; i < info.post.length; i++) {
          this.postImg.push({'name': info.post[i].slice(38), 'url': info.post[i]})
        }
        //比价图片也要显示
        for (let i = 0; i < info.comparison.length; i++) {
          this.priceImg.push({
            'name': info.comparison[i].url.slice(38, -1),
            'url': info.comparison[i].url,
            'time': info.comparison[i].time
          })
        }
        this.priceDate = this.priceImg[0].time;
      } else {
        //为了清空表单
        this.form = {...this.formBack};
        this.disabledTitleFlag = false;
        this.disabledClassFlag = false;
        this.buttonInfo = '确认新增';
      }
    },
    //规格编辑
    editSpecifications(info) {
      // if(info.status === 3){
      //   this.$message({
      //     type: 'error',
      //     message: '商品审核中，无法新增规格！'
      //   });
      // }else{
      this.mode = '新增规格';
      this.buttonInfo = '确认新增';
      this.form.spuTitle = info.title;
      this.form.spuClassId = info.classId;
      this.form.spuDescription = info.description;
      this.form.skuPrice = info.price;
      this.form.skuStock = info.stock;
      this.form.skuTag = info.tag;
      this.form.skuSpecification = info.specification;
      this.form.source = info.source;
      //图片有bug
      // this.imageList = info.image;
      this.spuId = info.spuId;
      this.skuId = info.id;
      this.sales = info.sales;
      this.dialogFormVisible = true;
      this.disabledTitleFlag = true;
      this.disabledClassFlag = true;
      this.imageList = [];
      this.postImg = [];
      this.priceImg = [];
      this.priceDate = '';
      for (let i = 0; i < info.image.length; i++) {
        this.imageList.push({'name': info.image[i].slice(38, -1), 'url': info.image[i]})
        // console.log(this.imageList,'---');
      }
      for (let i = 0; i < info.post.length; i++) {
        this.postImg.push({'name': info.post[i].slice(38, -1), 'url': info.post[i]})
      }
      //  不同规格的比价图片，是用同一个还是每新增一次就加？
      for (let i = 0; i < info.comparison.length; i++) {
        this.priceImg.push({
          'name': info.comparison[i].url.slice(38, -1),
          'url': info.comparison[i].url,
          'time': info.comparison[i].time
        })
      }
      this.priceDate = this.priceImg[0].time;
      // }
    },
    //sku，包括价格、规格
    editProductBySku(image, post) {
      this.specificationForm.id = this.skuId;
      this.specificationForm.spuId = this.spuId;
      this.specificationForm.tag = this.form.skuTag;
      this.specificationForm.price = this.form.skuPrice;
      this.specificationForm.specification = this.form.skuSpecification;
      this.specificationForm.image = image;
      this.specificationForm.post = post;
      this.$store.dispatch("Product/editProductBySku", this.specificationForm)
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log("编辑sku", res);
            }
            this.editProductBySpu();
            this.setStock(this.skuId, this.form.skuStock);
            this.$refs['form'].resetFields();
            this.imageList = [];
            this.postImg = [];
            this.productForm.sku.image = [];
            this.productForm.sku.post = [];
            this.productForm.spu.image = [];
            this.getTableData();
            this.specificationForm = {};
            console.log(this.imageList, "====");
            this.dialogFormVisible = false;
          })
          .catch((res) => {
            //重名
            this.editSpecFlag = true;
            this.$confirm(`${res.response.data.message}，请重新输入`, '警告', {
              confirmButtonText: '确定',
              type: 'warning'
            })
                .then(() => {
                  this.$message({
                    type: 'info',
                    message: '继续编辑'
                  });
                })
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
      this.specificationForm = {}
    },
    //spu级别的编辑，包括名称和描述
    editProductBySpu() {
      this.specificationForm.id = this.spuId;
      this.specificationForm.title = this.form.spuTitle;
      this.specificationForm.description = this.form.spuDescription;
      this.$store.dispatch("Product/editProductBySpu", this.specificationForm)
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log("编辑spu", res);
            }
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
      this.specificationForm = {}
    },
    //设置库存
    setStock(id, stock) {
      this.$store.dispatch("Product/setStock", {
        skuId: id,
        stock: stock
      })
          .then((res) => {
            this.getTableData()
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log("库存编辑", res);
            }
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
    },
    //提交表单
    onSubmit(formName) {
      this.productForm.spu.title = this.form.spuTitle;
      this.productForm.spu.description = this.form.spuDescription;
      this.productForm.spu.classId = Number(this.form.spuClassId);
      this.productForm.sku.tag = this.form.skuTag;
      this.productForm.sku.specification = this.form.skuSpecification;
      this.productForm.sku.price = Number(this.form.skuPrice);
      this.productForm.sku.stock = this.form.skuStock;
      this.productForm.sku.source = this.form.source;
      this.imageList.forEach(item => {
        this.productForm.spu.image.push(item.url)
        this.productForm.sku.image.push(item.url)
      })
      if (this.postImg.length !== 0) {
        this.postImg.forEach(item => {
          this.productForm.sku.post.push(item.url)
        })
      }
      //比价图片
      if (this.priceImg.length !== 0) {
        this.priceImg.forEach(item => {
          this.productForm.sku.comparison.push({
            url: item.url,
            time: item.time
          })
        })
      }
      if (this.mode === '新建商品') {
        this.$refs['form'].validate((valid) => {
          if (valid && this.imageList.length !== 0) {
            this.$store.dispatch("Product/addProductBySpu", this.productForm)
                .then((res) => {
                  if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                    console.log(res);
                    console.log(formName)
                  }
                  this.getTableData();
                  this.$refs[formName].resetFields();
                  //数据的清空只能在完全正确的操作下进行
                  this.imageList = [];
                  this.postImg = [];
                  this.priceImg = [];
                  this.productForm.sku.image = [];
                  this.productForm.sku.post = [];
                  this.productForm.sku.comparison = [];
                  this.productForm.spu.image = [];
                  this.dialogFormVisible = false;
                  this.$message({
                    type: 'success',
                    message: '新建商品成功!'
                  });
                })
                .catch((res) => {
                  this.$confirm(`${res.response.data.message}，请重新输入`, {
                    confirmButtonText: '确定',
                    type: 'warning'
                  })
                      .then(() => {
                        this.$message({
                          type: 'info',
                          message: '继续编辑'
                        });
                      })
                  if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                    console.log(res.response);
                  }
                })
          } else {
            this.imgValid = false;
            return false;
          }
        })
      } else if (this.mode === '新增规格') {
        this.specificationForm = {...this.productForm.sku};
        // this.specificationForm.image = this.productForm.spu.image;
        this.specificationForm.spuId = this.spuId;
        this.specificationForm.id = this.skuId;
        // this.specificationForm.status = this.choice;
        this.specificationForm.sales = this.sales;
        this.specificationForm.classId = this.productForm.spu.classId;
        this.specificationForm.description = this.productForm.spu.description;
        this.specificationForm.title = this.productForm.spu.title;
        this.$refs['form'].validate((valid) => {
          if (valid && this.imageList.length !== 0 && this.priceImg.length !== 0) {
            this.$store.dispatch("Product/addProductBySku", this.specificationForm)
                .then((res) => {
                  this.getTableData();
                  this.specificationForm = {};
                  if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                    console.log(res);
                  }
                  this.$refs[formName].resetFields();
                  this.imageList = [];
                  this.postImg = [];
                  this.priceImg = [];
                  this.productForm.sku.image = [];
                  this.productForm.sku.post = [];
                  this.productForm.spu.image = [];
                  this.productForm.sku.comparison = [];
                  this.dialogFormVisible = false;
                  this.$message({
                    type: 'success',
                    message: '新增规格成功!'
                  });
                })
                .catch((res) => {
                  this.$confirm(`${res.response.data.message}，请重新输入`, {
                    confirmButtonText: '确定',
                    type: 'warning'
                  })
                      .then(() => {
                        this.$message({
                          type: 'info',
                          message: '继续编辑'
                        });
                      })
                  if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                    console.log(res);
                  }
                })
          } else {
            this.imgValid = false;
            return false;
          }
        })

      } else if (this.mode === '编辑商品' || this.mode === '编辑待审核商品') {
        // if(this.changedName !== this.form.spuTitle){
        //   this.$confirm('编辑时修改商品名称将会应用到其他规格的商品中，是否继续？', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(() => {
        //sku级别的编辑
        // this.editProductBySku(this.productForm.sku.image, this.productForm.sku.post)
        this.specificationForm.id = this.skuId;
        this.specificationForm.spuId = this.spuId;
        this.specificationForm.tag = this.form.skuTag;
        this.specificationForm.price = this.form.skuPrice;
        this.specificationForm.specification = this.form.skuSpecification;
        this.specificationForm.source = this.form.source;
        this.specificationForm.image = this.productForm.sku.image;
        this.specificationForm.post = this.productForm.sku.post;
        //比价图片
        this.specificationForm.comparison = this.productForm.sku.comparison;
        this.$refs['form'].validate((valid) => {
          if (valid && this.imageList.length !== 0) {
            this.$store.dispatch("Product/editProductBySku", this.specificationForm)
                .then((res) => {
                  if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                    console.log("编辑sku", res);
                  }
                  this.editProductBySpu();
                  this.setStock(this.skuId, this.form.skuStock);
                  this.imageList = [];
                  this.postImg = [];
                  this.priceImg = [];
                  this.productForm.sku.image = [];
                  this.productForm.sku.post = [];
                  this.productForm.spu.image = [];
                  //比价图片
                  this.productForm.sku.comparison = [];
                  this.getTableData();
                  this.specificationForm = {};
                  if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                    console.log(this.imageList, "====");
                  }
                  this.$refs['form'].resetFields();
                  this.dialogFormVisible = false;
                  if (this.mode === '编辑待审核商品') {
                    this.requestRecheck(this.skuId);
                  }
                  this.$message({
                    type: 'success',
                    message: '编辑成功!'
                  });
                })
                .catch((res) => {
                  //重名
                  this.editSpecFlag = true;
                  this.$confirm(`${res.response.data.message}，请重新输入`, {
                    confirmButtonText: '确定',
                    type: 'warning'
                  })
                      .then(() => {
                        this.$message({
                          type: 'info',
                          message: '继续编辑'
                        });
                      })
                  if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                    console.log(res);
                  }
                })
          } else {
            this.imgValid = false;
            return false;
          }
        })
      }
    },
    //处理折扣，进入折扣页面，单个
    handleSingleDiscount(val) {
      val.promotion.forEach((item, index) => {
        this.promotion.selectedPromotionTag[index] = {
          promotionId: item.promotionId,
          title: item.title,
        }
      })
      if(!this.$store.state.visitorMode && GLOBAL.debugMode){
        console.log(this.promotion.selectedPromotionTag, '+++')
      }
      this.promotion.batchMode = false;
      this.promotion.dialogVisible = true;
      this.promotion.product.spuId = val.spuId;
      // 商品的促销
      this.$store.dispatch('Product/getPromotionList')
          .then((res) => {
            this.promotion.existedPromotionTag = res.data.data;
            // console.log(JSON.parse(this.promotion.existedPromotionTag[0].content));
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
          })
    },
    //  添加折扣
    addPromotionTag(val) {
      // if(!this.promotion.batchMode){
      //非批量
      // if(this.promotion.selectedPromotionTag.indexOf(val) === -1){
      //   this.promotion.selectedPromotionTag.push(val);
      let i = -1;
      this.promotion.selectedPromotionTag.forEach((item) => {
        if (item.promotionId === val.id) {
          i = 1;
        }
      })
      if (i !== 1) {
        this.promotion.selectedPromotionTag.push({
          promotionId: val.id,
          title: val.title,
        })
      }
      // }
      // let arr = [];
      // arr.push(this.promotion.product.spuId);
      //val.id是因为这里是从getList里面获取的活动列表
      // this.$store.dispatch('Product/putOnPromotion', {
      //   promotionId: {promotionId: val.id},
      //   arr: arr})
      // .then((res) => {
      //   console.log(res);
      //   //
      //   this.promotion.product.promotion.push(val);
      // })
      // .catch((err) => {
      //   console.log(err);
      // })
      // }else{
      //  批量
      //   let arr = [];
      //   for(let item of this.promotion.multiTableData){
      //     let tmp = -1;
      //     for(let p of item.promotion){
      //       if(p.promotionId === val.id){
      //         tmp = 1;
      //       }
      //     }
      //     if(tmp !== 1){
      //       //不存在，则添加渲染
      //       item.promotion.push({
      //         createdTime: val.createdTime,
      //         promotionId: val.id,
      //         title: val.title,
      //         content: val.content,
      //         type: val.type,
      //       });
      //     }
      //     arr.push(item.spuId);
      //   }
      // this.$store.dispatch('Product/putOnPromotion', {
      //   promotionId: {promotionId: val.id},
      //   arr: arr})
      //     .then((res) => {
      //       console.log(res);
      //       //
      //       // this.promotion.product.promotion.push(val);
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //     })
      // }
    },
    //  删除折扣
    deleteSinglePromotionTag(val) {
      this.promotion.selectedPromotionTag.splice(
          this.promotion.selectedPromotionTag.indexOf(val), 1);
      // let arr = [];
      // arr.push(this.promotion.product.spuId);
      // console.log(val);
      //val.promotionId是因为这里是从商品的promotion属性里获取的
      // this.$store.dispatch('Product/removePromotion', {
      //   promotionId: {promotionId: val.promotionId},
      //   arr: arr})
      //     .then((res) => {
      //       console.log(res);
      //       let i = 0;
      //       this.promotion.product.promotion.forEach((item,index) => {
      //         if(item.promotionId === val.id){
      //           i = index;
      //         }
      //       })
      //       this.promotion.product.promotion.splice(i, 1);
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //     })
    },
    //  批量处理折扣
    handleMultiDiscount() {
      if (this.multipleSelection.length === 0) {
        this.$alert('未选中任何商品', '警告', {
          confirmButtonText: '确定',
          type: 'warning'
        })
      } else {
        this.promotion.selectedPromotionTag = [];
        this.promotion.batchMode = true;
        this.promotion.dialogVisible = true;
        this.promotion.multiTableData = this.multipleSelection;
        console.log(this.multipleSelection);
        this.$store.dispatch('Product/getPromotionList')
            .then((res) => {
              this.promotion.existedPromotionTag = res.data.data;
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
            })
            .catch((err) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(err);
              }
            })
      }
    },
    // deleteMultiPromotionTag(promotionVal, spuId){
    //   let arr = [];
    //   arr.push(spuId);
    //   //val.promotionId是因为这里是从商品的promotion属性里获取的
    //   this.$store.dispatch('Product/removePromotion', {
    //     promotionId: {promotionId: promotionVal.promotionId},
    //     arr: arr})
    //       .then((res) => {
    //         console.log(res);
    //         this.promotion.multiTableData.forEach((item) => {
    //           if(item.spuId === spuId){
    //             item.promotion.splice(item.promotion.indexOf(promotionVal), 1);
    //           }
    //         })
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       })
    // },
    //  关闭折扣对话框
    submitPromotionList() {
      this.promotion.dialogVisible = false;
      let payload = {
        promotionIdList: [],
        spuIdList: [],
      };
      this.promotion.selectedPromotionTag.forEach((item) => {
        payload.promotionIdList.push(item.promotionId);
      });
      if (!this.promotion.batchMode) {
        payload.spuIdList.push(this.promotion.product.spuId);
      } else {
        this.promotion.multiTableData.forEach((item) => {
          payload.spuIdList.push(item.spuId);
        });
      }
      this.$store.dispatch('Product/submitPromotionList', payload)
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.getOnSaleList();
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
          })
    },
    //  取消活动设置
    cancelPromotionEdit() {
      this.promotion.dialogVisible = false;
      this.promotion.selectedPromotionTag = [];
      this.promotion.existedPromotionTag = [];
      // this.promotion.product.promotion = [];
      if(!this.$store.state.visitorMode && GLOBAL.debugMode){
        console.log(this.promotion);
      }
    },
    //  置顶
    pinProductBySpuId(val) {
      this.$confirm("确认置顶这件商品吗？", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            this.$store.dispatch("Product/pinProductBySpuId", {
              spuId: val,
            })
                .then((res) => {
                  if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                    console.log(res);
                  }
                  this.getTableData();
                })
                .catch((err) => {
                  if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                    console.log(err);
                  }
                })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            });
          });
    },
    //  取消置顶
    unpinProductBySpuId(val) {
      this.$confirm("确认置顶这件商品吗？", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            this.$store.dispatch("Product/unpinProductBySpuId", {
              spuId: val,
            })
                .then((res) => {
                  if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                    console.log(res);
                  }
                  this.getTableData();
                })
                .catch((err) => {
                  if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                    console.log(err);
                  }
                })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已退出操作'
            });
          });
    },
    //多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection);
    },
    selectAll() {
      console.log(this.multipleSelection);
    },
    //批量操作：上架
    batchOperationOfOnSale() {
      if (this.multipleSelection.length === 0) {
        this.$alert('未选中任何商品', '警告', {
          confirmButtonText: '确定',
          type: 'warning'
        })
      } else {
        this.$confirm(`批量上架${this.multipleSelection.length}件商品, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.multipleSelection.forEach(item => {
            this.selectedIds.push(item.id)
          })
          this.$store.dispatch("Product/onShelfProduct", this.selectedIds)
              .then((res) => {
                if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                  console.log(res);
                }
                this.getTableData();
              })
              .catch((res) => {
                if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                  console.log(res);
                }
              })
          this.selectedIds = [];
          this.$message({
            type: 'success',
            message: '上架成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消上架'
          });
        });
      }
    },
    //批量操作：下架
    batchOperationOfOffSale() {
      if (this.multipleSelection.length === 0) {
        this.$alert('未选中任何商品', '警告', {
          confirmButtonText: '确定',
          type: 'warning'
        })
      } else {
        this.$confirm(`批量下架${this.multipleSelection.length}件商品, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.multipleSelection.forEach(item => {
            this.selectedIds.push(item.id)
          })
          this.$store.dispatch("Product/offShelfProduct", this.selectedIds)
              .then((res) => {
                if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                  console.log(res);
                }
                this.getTableData();
              })
              .catch((res) => {
                if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                  console.log(res);
                }
              })
          this.selectedIds = [];
          this.$message({
            type: 'success',
            message: '下架成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消下架'
          });
        });
      }
    },
    //上架
    onShelfProduct(id) {
      this.$confirm('确认上架吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = [];
        ids.push(id)
        this.$store.dispatch("Product/onShelfProduct", ids)
            .then((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
              this.getTableData();
            })
            .catch((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
            })
        this.$message({
          type: 'success',
          message: '上架成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消上架'
        });
      });
    },
    //下架
    downShelfProduct(id) {
      this.$confirm('确认下架吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = [];
        ids.push(id)
        this.$store.dispatch("Product/offShelfProduct", ids)
            .then((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
              this.getTableData();
            })
            .catch((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
            })
        this.$message({
          type: 'success',
          message: '下架成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消下架'
        });
      });
    },
    //删除
    deleteProduct(id, status) {
      if (status === 3) {
        this.$message({
          type: 'error',
          message: '商品审核中，无法删除！'
        });
      } else {
        this.$confirm('确认删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch("Product/deleteProduct", {skuId: Number(id)})
              .then((res) => {
                if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                  console.log(res);
                }
                this.getTableData();
              })
              .catch((res) => {
                if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                  console.log(res);
                }
              })
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },
    //撤回提交的审核，平台方
    withdrawPending(id) {
      this.$confirm('确认撤销提交审核吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = [];
        ids.push(id)
        this.$store.dispatch("Product/withdrawPending", ids)
            .then((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
              this.getTableData();
            })
            .catch((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
            })
        this.$message({
          type: 'success',
          message: '撤销成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消撤销操作'
        });
      });
    },
    //编辑后再提交审核
    requestRecheck(id) {
      // this.mode = '编辑商品';
      // await this.toRegisterOrEdit('编辑商品', info);
      // this.onSubmit('form');
      let ids = [];
      ids.push(id);
      this.$store.dispatch('Product/requestRecheck', ids)
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.getTableData();
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
    },
    //搜索
    searchSkuProduct(key) {
      this.$store.dispatch("Product/searchByKeyAndClassIdAndStatus", {
        classId: this.leftMenuBar.categoryChoice,
        page: this.pageInfo.current,
        pageSize: this.pageInfo.size,
        order: this.orderMethod.order,
        orderKey: this.orderMethod.orderKey,
        status: this.statusMenu.choiceStatus,
        key: key
      })
          .then((res) => {
            this.tableData = res.data.data.list;
            this.pageInfo.total = res.data.data.totalCount;
            this.tableData.forEach(item => {
              //去除[""]这样的不合法图片
              if (item.post.length === 1 && item.post[0] === "") {
                item.post = []
              }
            })
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log("搜索结果：", res);
            }
          })
          .catch((res => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          }))
    },
    // 分页切换当前页码时调用
    handleCurrentPageChange(currentPage) {
      this.pageInfo.current = currentPage;
      this.getTableData()
    },
    // 分页尺寸更换时候调用
    handlePageSizeChange(pageSize) {
      this.pageInfo.current = 1;
      this.pageInfo.size = pageSize;
      this.getTableData();
    },
    //获取表格数据
    getTableData() {
      if (this.statusMenu.choiceIndex === '1') {
        //已上架
        this.onSaleDisabledFlag = true;
        this.offSaleDisabledFlag = false;
        this.getOnSaleList();
      } else if (this.statusMenu.choiceIndex === '0') {
        //已下架
        this.offSaleDisabledFlag = true;
        this.onSaleDisabledFlag = false;
        this.getOffSaleList();
      } else if (this.statusMenu.choiceIndex === '3') {
        //已售罄
        this.onSaleDisabledFlag = true;
        this.offSaleDisabledFlag = true;
        this.getOutOfStockList();
      } else if (this.statusMenu.choiceIndex === '2') {
        //可售
        this.onSaleDisabledFlag = false;
        this.offSaleDisabledFlag = true;
        this.getNewList();
      } else if (this.statusMenu.choiceIndex === '4') {
        this.onSaleDisabledFlag = true;
        this.offSaleDisabledFlag = true;
        this.getPendingOrUncheckedList();
      } else {
        //全部商品
        this.onSaleDisabledFlag = true;
        this.offSaleDisabledFlag = true;

        this.getListByClass();
      }
    },
    //可售
    getNewList() {
      this.$store.dispatch("Product/getNewList", {
        classId: this.leftMenuBar.categoryChoice,
        order: this.orderMethod.order,
        orderKey: this.orderMethod.orderKey,
        page: this.pageInfo.current,
        pageSize: this.pageInfo.size
      })
          .then((res) => {
            this.tableData = res.data.data.list;
            this.pageInfo.total = res.data.data.totalCount;
            this.tableData.forEach(item => {
              //去除[""]这样的不合法图片
              if (item.post.length === 1 && item.post[0] === "") {
                item.post = []
              }
            })
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.tableDataLoading = false;
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
    },
    //已上架
    getOnSaleList() {
      this.$store.dispatch("Product/getOnSaleList", {
        classId: this.leftMenuBar.categoryChoice,
        order: this.orderMethod.order,
        orderKey: this.orderMethod.orderKey,
        page: this.pageInfo.current,
        pageSize: this.pageInfo.size
      })
          .then((res) => {
            this.tableData = res.data.data.list;
            this.pageInfo.total = res.data.data.totalCount;
            this.tableData.forEach(item => {
              //去除[""]这样的不合法图片
              if (item.post.length === 1 && item.post[0] === "") {
                item.post = []
              }
            })
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.tableDataLoading = false;
            // if(this.promotion.batchMode){
            //   this.promotion.multiTableData = this.multipleSelection;
            // }
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
    },
    //已售罄
    getOutOfStockList() {
      this.$store.dispatch("Product/getOutOfStockList", {
        classId: this.leftMenuBar.categoryChoice,
        order: this.orderMethod.order,
        orderKey: this.orderMethod.orderKey,
        page: this.pageInfo.current,
        pageSize: this.pageInfo.size
      })
          .then((res) => {
            this.tableData = res.data.data.list;
            this.pageInfo.total = res.data.data.totalCount;
            this.tableData.forEach(item => {
              //去除[""]这样的不合法图片
              if (item.post.length === 1 && item.post[0] === "") {
                item.post = []
              }
            })
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.tableDataLoading = false;
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
    },
    //已下架
    getOffSaleList() {
      this.$store.dispatch("Product/getOffSaleList", {
        classId: this.leftMenuBar.categoryChoice,
        order: this.orderMethod.order,
        orderKey: this.orderMethod.orderKey,
        page: this.pageInfo.current,
        pageSize: this.pageInfo.size
      })
          .then((res) => {
            this.tableData = res.data.data.list;
            this.pageInfo.total = res.data.data.totalCount;
            this.tableData.forEach(item => {
              //去除[""]这样的不合法图片
              if (item.post.length === 1 && item.post[0] === "") {
                item.post = []
              }
            })
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.tableDataLoading = false;
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
    },
    //  待审核
    getPendingOrUncheckedList() {
      this.$store.dispatch("Product/getPendingOrUncheckedList", {
        classId: this.leftMenuBar.categoryChoice,
        order: this.orderMethod.order,
        orderKey: this.orderMethod.orderKey,
        page: this.pageInfo.current,
        pageSize: this.pageInfo.size
      })
          .then((res) => {
            this.tableData = res.data.data.list;
            this.pageInfo.total = res.data.data.totalCount;
            this.tableData.forEach(item => {
              //去除[""]这样的不合法图片
              if (item.post.length === 1 && item.post[0] === "") {
                item.post = []
              }
            })
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.tableDataLoading = false;
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
    },
    //  全部商品
    getListByClass() {
      this.$store.dispatch("Product/getListByClass", {
        classId: this.leftMenuBar.categoryChoice,
        order: this.orderMethod.order,
        orderKey: this.orderMethod.orderKey,
        page: this.pageInfo.current,
        pageSize: this.pageInfo.size
      })
          .then((res) => {
            this.tableData = res.data.data.list;
            this.pageInfo.total = res.data.data.totalCount;
            //保存全部商品的数量
            this.totalCountByAllStatus = res.data.data.totalCount;
            this.tableData.forEach(item => {
              //去除[""]这样的不合法图片
              if (item.post.length === 1 && item.post[0] === "") {
                item.post = []
              }
            })
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.tableDataLoading = false;
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
    },
    //初始化页面数据
    async initPageData() {
      await this.getProductCategories();
      this.leftMenuBar.activeIndex1 = this.categories[0].id.toString();
      this.leftMenuBar.categoryChoice = this.categories[0].id.toString();
      this.getTableData();
    },
    //表头样式
    headerClass() {
      return 'background: #EBEEF5; text-align: center'
    },
    //获取类别
    getProductCategories() {
      return new Promise((resolve, reject) => {
        this.$store.dispatch("Product/getProductCategories")
            .then((res) => {
              this.categories = res.data.data;
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
              resolve("商品类别加载成功！");
            })
            .catch(() => {
              reject("商品列表加载失败！");
            });
      });
    },
    //添加类别
    addCategories() {
      if (this.title !== '') {
        this.$store.dispatch("Product/addCategories", {title: this.title})
            .then((res) => {
              this.getProductCategories();
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
            })
            .catch((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
              if (this.GLOBAL.debugMode) {
                console.log("addCategories");
              }
            })
        this.title = '';
        this.dialogFormVisible2 = false;
      } else {
        this.$confirm('分类名称输入为空', '提示', {
          confirmButtonText: '返回',
          cancelButtonText: '退出',
          type: 'warning'
        }).then(() => {
        })
            .catch(() => {
              this.dialogFormVisible2 = false;
            })
      }
    },
    //  上移类别
    moveUpCategory(category) {
      if (this.categories.length !== 0) {
        let cur = this.categories.indexOf(category);
        let prev = this.categories.indexOf(category) - 1;
        //es6解构
        [this.categories[cur], this.categories[prev]] = [this.categories[prev], this.categories[cur]];
      }
      let arr = [];
      this.categories.forEach((item) => {
        arr.push(item.title);
      })
      this.$store.dispatch('Product/editCategoriesPriority', arr)
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.getProductCategories();
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
          })
    },
    //  下移类别
    moveDownCategory(category) {
      if (this.categories.length !== 0) {
        let cur = this.categories.indexOf(category);
        let next = this.categories.indexOf(category) + 1;
        //es6解构
        [this.categories[cur], this.categories[next]] = [this.categories[next], this.categories[cur]];
      }
      let arr = [];
      this.categories.forEach((item) => {
        arr.push(item.title);
      })
      this.$store.dispatch('Product/editCategoriesPriority', arr)
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.getProductCategories();
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
          })
    },
    //  编辑商品分类的名称
    editCategoryName(category) {
      if(!this.$store.state.visitorMode && GLOBAL.debugMode){
        console.log(category);
      }
      this.editCategoryNameVal.inputFlag = true;
      this.editCategoryNameVal.categoryVal = category.title;
      if(!this.$store.state.visitorMode && GLOBAL.debugMode){
        console.log(this.editCategoryNameVal.categoryVal);
      }
      this.editCategoryNameVal.categoryIndex = this.categories.indexOf(category)
    },
    //  提交商品名称修改
    submitCategoryName(category) {
      this.$store.dispatch('Product/editCategoriesName', {
        newTitle: this.editCategoryNameVal.categoryVal,
        classId: category.id
      })
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.editCategoryNameVal.inputFlag = false;
            this.getProductCategories();
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
          })
    },
    //  删除类别
    deleteCategory(val) {
      if (this.totalCountByAllStatus !== 0) {
        this.$alert("当前分类下还有商品，请先改变这些商品的分类，再删除该分类！", "提示", {
          confirmButtonText: '确定',
          type: 'warning',
          callback: () => {
            this.$message({
              type: 'warning',
              message: '操作已取消'
            });
          }
        })
      } else {
        this.$confirm("是否确认删除该分类？", "提示", {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
            .then(() => {
              this.$store.dispatch('Product/deleteCategory', {classId: val})
                  .then(() => {
                    this.getProductCategories();
                    this.$message({
                      type: 'success',
                      message: '成功删除类别'
                    });
                  })
                  .catch((err) => {
                    if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                      console.log(err);
                    }
                  })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除类别'
              });
            })
      }
    },
    //处理意外退出的情况
    handleDialogClose(done) {
      this.disabledFlag = false;
      this.$confirm("操作未保存，是否退出？")
          .then(() => {
            // this.$refs['form'].resetFields();
            done();
          })
          .catch(() => {
            // this.$refs['form'].resetFields();
          });
    },
    //初始化对话框
    initDialog(formName) {
      this.imageList = [];
      this.postImg = [];
      this.priceImg = [];
      this.priceDate = '';
      this.$refs[formName].resetFields();
      this.productForm.sku.image = [];
      this.productForm.sku.post = [];
      this.productForm.spu.image = [];
      this.productForm.sku.comparison = [];
      this.imgValid = true;
      console.log("关闭对话框，初始化对话框");
    },
    initDialog2() {
      this.title = '';
    },
    //类别菜单选择
    handleCategorySelect(key) {
      this.leftMenuBar.categoryChoice = key;
    },
    //状态菜单选择
    handleStatusSelect(key) {
      this.statusMenu.choiceIndex = key;
      this.menuItems.forEach((item) => {
        if (item.index === key) {
          this.statusMenu.choiceStatus = item.title;
        }
      })
      if (this.statusMenu.choiceStatus === "全部商品") {
        this.statusMenu.choiceStatus = "全部";
      }
      console.log(this.statusMenu.choiceStatus);
      this.pageInfo.current = 1;
      this.pageInfo.size = 10;
    },
  },
  watch: {
    //状态改变时，重新请求数据
    "statusMenu.choiceIndex"() {
      this.searchInput = '';
      this.editCategoryNameVal.inputFlag = false;
      this.tableDataLoading = true;
      this.getTableData();
    },
    //商品类别改变时
    "leftMenuBar.categoryChoice"() {
      this.searchInput = '';
      this.editCategoryNameVal.inputFlag = false;
      this.tableDataLoading = true;
      this.getTableData();
    },
    //dialog打开、关闭时，都刷新数据
    dialogFormVisible: {
      handler: function () {
        this.tableDataLoading = true;
        this.getTableData();
      }
    },
    "orderMethod.order"() {
      this.tableDataLoading = true;
      this.getTableData();
    },
    "orderMethod.orderKey"() {
      this.tableDataLoading = true;
      this.getTableData();
    },
  },
};
</script>

<style scoped>
@import "../../style/InputCount.css";
@import "../../style/Color.css";

.el-menu.el-menu--horizontal {
  border-left: solid 1px #e6e6e6;
  border-bottom: unset;
}

.el-table td div .el-input {
  width: 50px;
}

/deep/ .el-aside {
  position: sticky;
  top: 10px !important;
  border-right: 1px solid rgb(230, 230, 230);
}

span {
  font-family: PingFangSC-Medium, PingFang SC;
  font-size: 15px;
}

.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}

/*上传图片控件的样式*/
.imageUpload div {
  display: flex;
}

/deep/ .el-upload--picture-card {
  height: 40px;
  width: 40px;
  line-height: unset;
}

/deep/ .el-upload--picture-card:after {
  content: '+';
}

/*已上传的图片缩略图样式*/
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  height: 40px;
  width: 40px;
}

.rejectReason {
  color: #8c939d;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  word-break: break-all;
  -webkit-line-clamp: 1; /*可以显示的行数，超出部分用...表示 */
  -webkit-box-orient: vertical;
}

/*表格底行*/
/deep/ .el-table__footer-wrapper tbody td.el-table__cell {
  background-color: #F4F4F5;
}

/*隐藏水平滚动条*/
/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}

/*分类中操作的按钮*/
.el-menu-item i {
  color: transparent;
}

.categoryEditBtn:focus .el-button--text i,
.categoryEditBtn:hover .el-button--text i,
.categoryEditBtn.is-active .el-button--text i {
  color: #409EFF;
  transition: border-color .3s, background-color .3s, color .3s;
}

.categoryEditBtn:focus .el-button--text i.el-icon-delete,
.categoryEditBtn:hover .el-button--text i.el-icon-delete,
.categoryEditBtn.is-active .el-button--text i.el-icon-delete {
  color: #f56c6c;
  transition: border-color .3s, background-color .3s, color .3s;
}

.editCategoryInput {
  width: 100px;
}

.editCategoryInput /deep/ .el-input__inner {
  padding: 0 5px;
  font-size: 14px;
}

/*活动*/
.salesPromotion {
  font-size: 15px;
  font-weight: 500;
  line-height: 2rem;
}

.salesPromotion .el-tag {
  cursor: pointer;
}

/*从第二个开始*/
.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
